import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"

import "./Header.vue?vue&type=style&index=0&id=8e296146&lang=scss&scoped=true"

import exportComponent from "/Users/xiaozhi/Documents/codeWork/Vue/Vue项目/mighty_project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e296146"]])

export default __exports__